import React from 'react';
import dubaiPoliceLogo from '../../assets/dubai-police-logo.png';

const ResultScreen = ({ generatedImage, styleName, onRetake, onNext }) => {
  return (
    <div className="h-screen relative overflow-hidden bg-gradient-to-b from-white via-[#F6FBF9] to-[#E4EFEA]">
      {/* Vertical spine */}
      <div className="forensic-spine" />

      {/* Background layers */}
      <div className="forensic-grid-overlay opacity-15" />
      <div className="forensic-map-overlay opacity-[0.04]" />
      <div className="forensic-circuit-lines" />

      {/* Green blocks */}
      <div className="forensic-block forensic-block-2 opacity-60" />
      <div className="forensic-corner-tl" />

      {/* Main content */}
      <div className="relative z-10 h-full flex flex-col px-8 py-6 gap-4">
        {/* Header */}
        <header className="flex justify-between items-start">
          <div className="pl-4">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#0e734b] font-semibold">Result Ready</p>
            <h1 className="text-2xl font-bold uppercase tracking-[0.1em] text-[#1A1A1A]">{styleName}</h1>
            <p className="text-[10px] tracking-[0.15em] uppercase text-[#6B7770] mt-1">
              نتيجة التحويل
            </p>
          </div>
          <img src={dubaiPoliceLogo} alt="Dubai Police" className="h-12 w-auto" />
        </header>

        {/* Header line */}
        <div className="h-[2px] bg-gradient-to-r from-[#0e734b] via-[#0e734b] to-transparent" style={{ backgroundSize: '40% 100%', backgroundRepeat: 'no-repeat' }} />

        {/* Image display - Fixed 2:3 aspect ratio container to prevent layout shift */}
        <main className="flex-1 flex items-center justify-center min-h-0 py-2">
          <div className="relative h-full max-h-full flex items-center justify-center">
            <div className="forensic-card p-3 h-full flex items-center justify-center" style={{ aspectRatio: '2/3' }}>
              <img
                src={generatedImage}
                alt="Transformed result"
                className="max-w-full max-h-full w-auto h-auto object-contain rounded-sharp border-2 border-[#0e734b]/20"
              />
            </div>
          </div>
        </main>

        {/* Action buttons - Bilingual */}
        <footer className="flex justify-center gap-4 py-2">
          <button
            onClick={onRetake}
            className="forensic-btn-secondary px-10 py-3 flex items-center gap-2"
          >
            <span>←</span>
            <span className="font-title uppercase">Retake</span>
            <span className="opacity-60">|</span>
            <span className="font-arabic">إعادة</span>
          </button>
          <button
            onClick={onNext}
            className="forensic-btn-primary px-12 py-4 flex items-center gap-2"
          >
            <span className="font-title uppercase">Get QR</span>
            <span className="text-white/60">|</span>
            <span className="font-arabic font-bold">احصل على الرمز</span>
            <span>→</span>
          </button>
        </footer>

        {/* Status */}
        <div className="flex items-center justify-center gap-2 text-[#6B7770] text-[10px] uppercase tracking-[0.2em]">
          <div className="w-2 h-2 bg-[#0e734b] rounded-sm" />
          <span>AI Transformation Complete</span>
          <div className="w-2 h-2 bg-[#0e734b] rounded-sm" />
        </div>
      </div>
    </div>
  );
};

export default ResultScreen;
